import { Typography } from '../../../components/Typography'
import { Table } from '../../../components/Table'
import { communityColumns } from '../constants'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { ROLES } from '../../Permission'
import moment, { Moment } from 'moment/moment'
import { useMemo } from 'react'
import { TCommunitySavingGoals } from '../types'
import { useSavingGoalsContext } from '../Providers/SavingGolasContextProvider'
import { useSavingGoalsHistoryContext } from '../Providers/SavingGoalsHistoryContextProvider'

export const CommunityTable = ({ period }: { period: Moment }) => {
  const user = useSelector(getUser)

  const isEditable = useMemo(
    () =>
      user.role === ROLES.COMMUNITY_PRESIDENT &&
      period.startOf('year').isSameOrAfter(moment().startOf('year')),
    [user, period]
  )

  const {
    actions: { setCommunitySavingGoal },
    state: { community }
  } = useSavingGoalsContext()

  const {
    actions: { selectItemToShowHistory }
  } = useSavingGoalsHistoryContext()

  const tableData = useMemo(() => {
    return community
      ? [
          {
            ...community,
            savings_goal: community.savings_goal ?? ''
          }
        ]
      : []
  }, [community])

  return (
    <div className="column gap-24">
      <Typography.Headline5>Community</Typography.Headline5>
      <Table<TCommunitySavingGoals>
        columns={communityColumns({
          isEditable,
          setCommunitySavingGoal,
          selectItemToShowHistory
        })}
        dataSource={tableData}
      />
    </div>
  )
}
